import React from 'react'
import { Icons } from '../../../constant'
import styles from '../../../sass/home.module.scss'

const Support = () => {
  return (
    <div className='section_innerWrapper'>
        <div className={styles.Support__wrapper}>
            <div className={styles.Support_item}>
                <img src={Icons.shipping} alt='shipping' />
                <div>
                    <div className={styles.Support_title}>Free Shipping</div>
                    <div className={styles.Support_subtitle}>Free shipping on orders over <span>2500.</span></div>
                </div>
            </div>
            <div className={styles.Support_item}>
                <img src={Icons.support} alt='support' />
                <div>
                    <div className={styles.Support_title}>Support</div>
                    <div className={styles.Support_subtitle}>24x7 Support</div>
                </div>
            </div>
            <div className={styles.Support_item}>
                <img src={Icons.secure} alt='secure' />
                <div>
                    <div className={styles.Support_title}>Secure Checkout</div>
                    <div className={styles.Support_subtitle}>We ensure 100% Payment Secure.</div>
                </div>
            </div>
            <div className={styles.Support_item}>
                <img src={Icons.cod} alt='cod' />
            </div>
        </div>
    </div>
  )
}

export default Support